"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Size;
(function (Size) {
    Size["SizeX1"] = "u-s1";
    Size["SizeX2"] = "u-s2";
    Size["SizeX3"] = "u-s3";
})(Size = exports.Size || (exports.Size = {}));
;
var Width;
(function (Width) {
    Width["WidthX1"] = "u-w1";
    Width["WidthX2"] = "u-w2";
    Width["WidthX3"] = "u-w3";
    Width["WidthX4"] = "u-w4";
    Width["WidthX6"] = "u-w6";
    Width["WidthX8"] = "u-w8";
})(Width = exports.Width || (exports.Width = {}));
;
var Height;
(function (Height) {
    Height["HeightX1"] = "u-h1";
    Height["HeightX2"] = "u-h2";
})(Height = exports.Height || (exports.Height = {}));
;
//# sourceMappingURL=Size.js.map